export var HEADER_SPACING_VERTICAL = 'S300';
export var CELL_SPACING_VERTICAL = 'S300';
export var CELL_SPACING_HORIZONTAL = 'S300';
export var HEADER_SPACING_VERTICAL_REDUCED = 'S200';
export var CELL_SPACING_VERTICAL_REDUCED = 'S200';
export var BORDER_COLOR = 'neutral10';
export var BORDER_WIDTH_OUTER = 2;
export var BORDER_WIDTH_INNER = 1;
export var BACKGROUND_COLOR_HEADER = 'neutral05';
export var BACKGROUND_COLOR_HEADER_STRIPED = 'neutral10';
export var BACKGROUND_SHADE_COLOR = 'neutral05';
export var ROW_HOVER_OUTLINE_COLOR = 'primary70';
export var ROW_HOVER_OUTLINE_WIDTH = 2;
export var ROW_HOVER_OUTLINE_OFFSET = -1;
export var thDefaultProps = {
  textAlign: 'left'
};
export var tdDefaultProps = {
  textAlign: 'left',
  verticalAlign: 'middle'
};